import { render, staticRenderFns } from "./TrailerDisplay.vue?vue&type=template&id=223a3c5e&"
import script from "./TrailerDisplay.vue?vue&type=script&lang=js&"
export * from "./TrailerDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports